import React from "react";
import { DropTarget } from "react-dnd-cjs";
import { NativeTypes } from "react-dnd-html5-backend-cjs";
import PropTypes from "prop-types";

import Icon from "components/library/Icon";

import styles from "./FileDropTarget.css";

const target = {
  drop(props, monitor) {
    if (props.onDrop) {
      props.onDrop(props, monitor);
    }
  },
};

const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
});

export class FileDropHandler extends React.Component {
  // This could be a stateless functional component, were it not for the fact that it's passed a ref by DropTarget.
  render() {
    const {
      canDrop,
      isOver,
      connectDropTarget,
      onInput,
      helpText,
    } = this.props;
    const isActive = canDrop && isOver;

    return connectDropTarget(
      <div className={styles.root}>
        <Icon
          className={styles.icon}
          name="image"
          description="Drop an image in this zone to upload it"
        />
        <div className={styles.prompt}>
          {isActive ? "Drop to upload" : "Drag an image here"}
        </div>
        {helpText && <div className={styles.help}>{helpText}</div>}
        <label className={styles.upload}>
          Choose an image to upload
          <input type="file" onChange={onInput} hidden />
        </label>
      </div>
    );
  }
}

FileDropHandler.propTypes = {
  canDrop: PropTypes.bool.isRequired,
  isOver: PropTypes.bool.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  helpText: PropTypes.string,
};

export default DropTarget(NativeTypes.FILE, target, collect)(FileDropHandler);
